import type { ReactNode } from "react";
import React from "react";
import { Accordion } from "react-bootstrap";
import { LandingAccordion } from "./LandingAccordion";
import { LandingContainer } from "./LandingContainer";

interface Props {
	title: string;
	questions: Record<string, ReactNode>;
	id?: string;
}

export class LandingGyikBig extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { title, questions, id } = this.props;

		return (
			<LandingContainer>
				<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">{title}</h2>
				<Accordion className="accordion-secondary" id={id}>
					{Object.keys(questions).map((question, index) => (
						<LandingAccordion key={index} id={`${index}BigFaq`} title={question}>
							{questions[question]}
						</LandingAccordion>
					))}
				</Accordion>
			</LandingContainer>
		);
	}
}
